<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class=" d-flex justify-content-between align-items-center p-2">
                <div class="transaction-title">Transactions</div>
                <button @click="toggleFilter">
                    <img class="search-icon" src="@/assets/images/icon/search.png" />
                </button>
            </div>
            <div class="p-2" v-if="hasResults">
              <template v-for="(transactions, date) in paginatedData" :key="date">
                <div class="date-title">
                    {{ format(new Date(date)) }}
                </div>
                <div  v-for="(item, index) in transactions" :key="index" @click="openDetail(item)" >
                  <div class="col-item d-flex justify-content-between align-items-center mt-2" >
                    <div class="col-time">{{ formatTime(item.datetime) }}</div>
                    <div class="payment">
                      <div v-if="formatToLowerCase(item.type) === 'eftpos'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/eftpos.png" alt="Eftpos" />
                      </div>
                      <div v-if="formatToLowerCase(item.type) === 'visa'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/visa.png" alt="Visa" />
                      </div>
                      <div v-if="formatToLowerCase(item.type) === 'mastercard'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/mastercard.png" alt="Mastercard" />
                      </div>
                      <div v-if="formatToLowerCase(item.type) === 'american express'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/amex.png" alt="Amex" />
                      </div>
                      <div class="fee-chargeback-text" v-if="item.type === 'Fee' || item.type === 'Chargeback' ">{{ item.type }}</div>
                      <div class="payment-text" v-if="item.type === 'Refund'">{{ item.type }}</div>
                    </div>
                    <div class="transaction-container">
                      <div class="col-value">{{ formatCurrency(item.we_pay_you) }}</div>
                      <div :class="{ 'text-transaction-status': item.transaction_status != null }">{{ item.transaction_status }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="p-2 no-result" v-else>
              <div class="no-result-text">No results found</div>
              <div class="search-again" @click="toggleFilter()">Search again</div>
            </div>
            <div class="mt-5 mb-5">&nbsp;</div>
        </div>
    </div>

    <div class="pagination-container"  v-if="!showDetail">
        <div class="pagination-left">
            <button @click="changePage(1)" :disabled="transactionStore.currentPage === 1">
            <img src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" class="arrow-icon" />
            </button>
            <button @click="changePage(transactionStore.currentPage - 1)" :disabled="transactionStore.currentPage === 1">
            <img src="@/assets/images/admin/arrow/prev.png" alt="Prev" class="arrow-icon" />
            </button>
        </div>
        
        <div class="pagination-center">
            <span class="page-info">
            Page 
            <input type="number" v-model.number="transactionStore.currentPage" @change="changePage(transactionStore.currentPage)" class="page-input" />
            of {{ totalPages }}
            </span>
        </div>
        
        <div class="pagination-right">
            <button @click="changePage(transactionStore.currentPage + 1)" :disabled="transactionStore.currentPage === totalPages">
            <img src="@/assets/images/admin/arrow/next.png" alt="Next" class="arrow-icon" />
            </button>
            <button @click="changePage(totalPages)" :disabled="transactionStore.currentPage === totalPages">
            <img src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" class="arrow-icon" />
            </button>
        </div>
    </div>    
    <Search 
      v-if="filterVisible"
      @search="search"
      @close="toggleFilter"
    />
    <Detail 
      v-if="showDetail"
      :initialIndex="selectedIndex"
      @close="closeDetail"
     />
</template>

<script setup>
import { ref,onMounted,computed } from 'vue';
import { useTransactionStore } from '@/store/driver/transaction';
import Detail from './detail.vue'
import Search from './search.vue';
import {onBeforeRouteLeave } from 'vue-router';



const transactionStore = useTransactionStore();

// 控制 Detail 組件顯示的狀態
const showDetail = ref(false);
const selectedIndex = ref(null);

const filterVisible = ref(false);
// 確認是否有結果
const hasResults = computed(() => transactionStore.totalEntries > 0);
const paginatedData = computed(() => transactionStore.paginatedData);
const totalPages = computed(() => transactionStore.totalPages);
const flattenedTransactions = computed(() =>
  Object.values(transactionStore.paginatedData).flat()
)


const changePage = async (page) => {
  transactionStore.changePage(page);
};

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const search = async () => {
  const filters = {
    fromDate: transactionStore.filters.fromDate,
    toDate: transactionStore.filters.toDate,
    transactionType: transactionStore.filters.transactionType !== 'all' ? transactionStore.filters.transactionType : '',
    reference: transactionStore.filters.reference
  };

  transactionStore.currentPage = 1;
  await transactionStore.fetchTransactions(1, transactionStore.itemsPerPage, filters);
  toggleFilter();
};

const formatToLowerCase = (str) => {
  return str ? str.toLowerCase() : ''; // 如果 str 存在則轉為小寫，否則返回空字串
};


// 修改日期格式為 dd-mm-yy
const format = (date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  // 使用一個月份名稱的陣列來取得月份名稱
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[date.getMonth()]; // 取得月份名稱

  return `${day} ${month} ${year}`;
};


// 修改時間格式為 hh:mm
const formatTime = (datetime) => {
  const date = new Date(datetime);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';

  return `${hours.toString().padStart(2, '0')}:${minutes}`;
};

const formatCurrency = (value) => {
  const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};


// 點擊交易項目以打開 Detail 組件
const openDetail = (transaction) => {
  const index = flattenedTransactions.value.findIndex(
    (item) => item === transaction
  );
  selectedIndex.value = index;
  showDetail.value = true;
};

// 關閉 Detail 組件
const closeDetail = () => {
  showDetail.value = false;
  selectedIndex.value = null;
};

// 重置篩選條件
const resetFilters = () => {
  transactionStore.filters.fromDate = '';
  transactionStore.filters.toDate = '';
  transactionStore.filters.transactionType = '';
  transactionStore.filters.reference = '';
};

onBeforeRouteLeave(() => {
  resetFilters();
  transactionStore.shouldResetFilters = false;
});


onMounted(async () => {
  // 等待頁面渲染完成，然後嘗試獲取 modal element
  changePage(1);
  await transactionStore.fetchTransactions();
});

</script>

<style scoped>

.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 90%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.transaction-title{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #1E1E2D;
}

.search-icon{
    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    gap: 10px;

    width: 36px;
    height: 36px;

    /* Grey 10% */
    background: #EEF1F4;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;
    cursor: pointer;

}


.date-title{
  height: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
  /* Portal/Portal – H7 */
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  /* 1E1E2D */
  color: #1E1E2D;


  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;

}

.col-item{
  /* Grey */
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #99A6B4;
}

.col-time{
  height: 26px;
  width: 15%; /* 調整這個比例以符合你的版面設計 */
  /* Portal/Portal – H7 */
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;

  /* Navy */
  color: #051C2C;


  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;

}

.payment{
  width: 20%; /* 設定固定寬度，確保位置一致 */
}

.fee-chargeback-text{
  width: 140.5px;
  margin-top: 3px;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;

  /* Teal */
  color: red;
}

.payment-text{
  width: 140.5px;
  margin-top: 3px;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;

  /* Teal */
  color: #189F95;
}

.payment-icon{
  width: 60px;
  height: auto;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}

.transaction-container {
  width: 30%; /* 設定固定寬度 */
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 將所有內容靠右對齊 */
}

.col-value{
  /* Portal/Portal – H6 */
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  text-align: right; /* 確保文字靠右對齊 */
  color: #051C2C;
}

.text-transaction-status{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: right; /* 確保文字靠右對齊 */
  color: #00C962;

}

.no-result {
  margin-top: 20px;
  background-color: #d9d9d9;
  border-radius: 12px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center; /* 確保文字居中 */
  padding: 20px; /* 增加一點內距來保持美觀 */
}

.no-result-text {
  font-family: 'Euclid Square';
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  color: #051C2C;
  margin-bottom: 8px; /* 與 search-again 保持距離 */
}

.search-again {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #5248DA;
  cursor: pointer; /* 可選：讓文字像按鈕一樣具有可點擊效果 */
}


/* Pagination section 固定在底部 */
.pagination-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px -2px 15px rgba(5, 28, 44, 0.15);
  border-radius: 12px 12px 0px 0px;
  z-index: 1;
}

.pagination-left,
.pagination-right {
  display: flex;
}

.pagination-center {
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 28px;
  height: 28px;
}

.page-info {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-input {
  width: 40px;
  height: 30px;
  text-align: center;
  font-size: 16px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 5px;
}

button {
  border: none;
  background: none;
  cursor: pointer;
}

</style>

